module.exports = __webpack_public_path__ + "img/pizzaset-777.3a9078f2.png";